import api from "../../../utils/appApi";
import {CardInputMask} from "../CardInputMask";
import moment from "moment";
import notify from "../../../utils/notify";
import Notify from "../../../utils/notify";
import {__loco} from "../../../utils/localization";
import {CheckoutCollapses} from "../checkoutCollapses";
import Validation from "../../../utils/inputsValidation";

const validation = new Validation();

export class CheckoutPayyoPaymentHandler {

    constructor(params = {}) {
        /**
         * Params may include
         *
         * callbacks: {
         *   stripeValidationError(error)
         *   stripeValidationSuccess(...)
         * }
         */
        this.params = params;

        /**
         * Errors coming from payyo are often confusing, so this is a way to map their strings to a more human-friendly form.
         * @type {{"[PCI-Proxy] Alias returned error: [1004] CC number is not valid (check modulo-10 failed)": *}}
         */
        this.errorsMap = {
            "[PCI-Proxy] Alias returned error: [1004] CC number is not valid (check modulo-10 failed)": __loco('Card number is not valid.')
        };


        /**
         * @type {{}}
         */
        this.state = {
            aliasId: null,
        };


        this.vault = null;



        this.selectors = {
            holder: '#holder',
            number: '#card-number',
            cvc: '#cvv',
            expires: '#card-term',
        };

        /**
         * Fields to listen before triggering validation actions regarding confirm payment button
         *
         * @type {{payer_email: string, payer_name: string, payer_phonenumber: string}}
         */
        this.fieldsToListen = {
            payer_name: '#payer_name',
            payer_email: '#payer_email',
            payer_phonenumber: '#payer_phonenumber'
        }


        if($(window).width() < 768) {
            // @todo: Remove mobile dependency.
            // this.selectors = {
            //     holder: '#mobile-holder',
            //     number: '#mobile-card-number',
            //     cvc: '#mobile-cvv',
            //     expires: '#mobile-card-term',
            // };
        }


        /**
         * Initialize input mask
         */
        new CardInputMask({
            numberInput: this.selectors.number,
            expiryInput: this.selectors.expires,
            cvcInput: this.selectors.cvc
        });


        // remove errors when typing in inputs
        $(document).on('change, keyup', '.checkout__item_wrapper input', function(){
           const $wrapper = $(this).closest('.checkout__item_wrapper');
           $wrapper.find('[data-payyo-error]').text('').hide();
        });
    }

    /**
     *
     */
    initialize()
    {
        const self = this;
        $(document).on('change', Object.values(self.fieldsToListen).join(', '), function(e){
            let filled = 0;
            $(Object.values(self.fieldsToListen)).each(function(){
                if($(this).val() !== '') {
                    filled++;
                }
            });

            setTimeout(function () {
                if(filled === Object.values(self.fieldsToListen).length) {
                    if(typeof self.params.callbacks.stripeValidationSuccess !== "undefined" ) {
                        self.params.callbacks.stripeValidationSuccess();
                    }
                }

                self.handleLiveInputValidation()

            })
        });

        $(document).on('input', Object.values(self.fieldsToListen).join(', '), function(e){
            self.handleLiveInputValidation()
        })

        $(document).on('change', '#checkOutTermsCondition', function(e){
            self.handleLiveInputValidation()
        })

        $(document).on('click', '#payyo-send', function(e){
            e.preventDefault();
            self.clearErrors();
            self.storeCard();
        });


        this.obtainVault();

    }

    handleLiveInputValidation() {

        const self = this;

    }

    /**
     * Obtain vault
     */
    obtainVault()
    {
        api.public.checkout.getPayyoVault({})
            .then(res => this.initializeVault(res))
            .catch(err => console.log(err));
    }

    /**
     *
     * @return {boolean}
     */
    hasAliasId()
    {
        return !!this.state.aliasId;
    }

    /**
     *
     * @return {null}
     */
    getAliasId()
    {
        return this.state.aliasId;
    }


    /**
     * @todo: handle else{}
     * @param response
     */
    initializeVault(response)
    {
        if(response.data.vault !== undefined && response.data.endpoint !== undefined && response.data.logo !== undefined) {
            this.vault = new TrekkPayVault(response.data.vault, {
                endpoint: response.data.endpoint,
                logo: response.data.logo
            });
        }
    }

    /**
     * Store card
     */
    storeCard()
    {
        // modal
        // vault.collectCreditCard().then(function (aliasId) {
        //     console.log(aliasId);
        // });


        // own form

        this.vault.storeCreditCard({
            holder: $(this.selectors.holder).val(),
            number: $(this.selectors.number).val(),
            cvc: $(this.selectors.cvc).val(),
            expires: this.getExpiry()
        }).then(function (aliasId) {
            console.log(aliasId);
            this.state.aliasId = aliasId;
        }).catch(err => this.renderErrors(err));
    }

    /**
     * Store card returning promise
     * @return {*}
     */
    storeCardPromise()
    {
        return this.vault.storeCreditCard({
            holder: $(this.selectors.holder).val(),
            number: $(this.selectors.number).val(),
            cvc: this.getCvv(),
            expires: this.getExpiry()
        });
    }

    /**
     * Convert from 12/22 to 2022-12, as Payyo expects this format
     * @return {string}
     */
    getExpiry()
    {
        const raw = $(this.selectors.expires).val();
        return moment(raw, 'MM/YY').format('YYYY-MM');
    }

    /**
     *
     * @return {jQuery|string|undefined}
     */
    getCvv()
    {
        return $(this.selectors.cvc).val();
    }

    /**
     *
     */
    clearErrors()
    {
        $(`[data-payyo-error]`).hide();
    }

    /**
     * Render errors
     * @todo: Currently errors from payyo have a weird-looking text format, example: Does not match the regex pattern ^[\d \-]{8,}$
     *
     * @param errors
     */
    renderErrors(errors)
    {
        const collapse = new CheckoutCollapses();

        collapse.openCollapse(collapse.getPaymentCollapse());

        if(errors.details.errors !== undefined) {
            const errorsGroup = errors.details.errors;

            for(let itm in errorsGroup) {
                if(itm !== '' && !!errorsGroup[itm]) {
                    $(`[data-payyo-error="${itm}"]`).text(errorsGroup[itm]).show();
                }
            }
        } else if(errors.message !== undefined) {
            const notifier = new Notify();
            let message = errors.message;

            // attempt localizing a more friendly error text
            if(!!this.errorsMap[message]) {
                message = this.errorsMap[message];
            }

            notifier.error(message);
        }
    }
}
